import {
    createProposal,
    deleteProposalById,
    readProposalById,
    readProposals,
    replaceProposal,
    setClientConfirmedProposal,
} from 'api/proposal';
import { ProposalFormData } from 'types/proposal';
import { CreateProposalRequest, GetProposalsRequest, UpdateProposalRequest } from 'api/proposal/types';
import { getTotalAmount } from 'components/Proposals/ProposalForm/utils';

export const createNewProposal = (data: ProposalFormData) => {
    const requestData: CreateProposalRequest = {
        ...data,
        total: getTotalAmount(data.lineItems),
    };
    return createProposal(requestData).then((res) => res.data);
};

export const estimateNewProposal = (data: ProposalFormData) => {
    const requestData: CreateProposalRequest = {
        ...data,
        total: getTotalAmount(data.lineItems),
    };
    return createProposal(requestData).then((res) => res.data);
};

export const updateProposal = (proposalIdId: string, data: ProposalFormData) => {
    const requestData: UpdateProposalRequest = {
        ...data,
        total: getTotalAmount(data.lineItems),
    };
    return replaceProposal(proposalIdId, requestData).then((res) => res.data);
};

export const getProposals = (params?: GetProposalsRequest) => {
    return readProposals(params).then((res) => res.data);
};

export const getProposalDetails = (id: string) => readProposalById({ id }).then(({ data }) => data);

export const getProposalFormData = (id: string) =>
    readProposalById({ id }).then(({ data }) => {
        const { title, appointmentId, contractorId, lineItems } = data;
        return {
            title,
            appointmentId,
            contractorId,
            lineItems: lineItems.map((item) => ({ ...item, total: item.total.toString() })),
        };
    });

export const deleteProposal = (id: string) => {
    return deleteProposalById({ id }).then((res) => res.data);
};

export const updateProposalConfirmation = (proposalId: string, isClientConfirmed: boolean) =>
    setClientConfirmedProposal(proposalId, { isClientConfirmed }).then((res) => res.data);
